var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9129 6.96156C13.897 6.86741 13.8145 6.8 13.719 6.8H8.2C8.08954 6.8 8 6.88954 8 7V9C8 9.11046 8.08954 9.2 8.2 9.2H11.3909C10.8962 10.5971 9.5669 11.6 8 11.6C6.0119 11.6 4.4 9.9881 4.4 8C4.4 6.0119 6.0119 4.4 8 4.4C8.8499 4.4 9.62878 4.69693 10.2442 5.19C10.3268 5.25623 10.4468 5.2532 10.5217 5.1783L11.9389 3.76109C12.019 3.68103 12.0169 3.55029 11.9315 3.47595C10.8783 2.55921 9.50591 2 8 2C4.6865 2 2 4.6865 2 8C2 11.3135 4.6865 14 8 14C11.3135 14 14 11.3135 14 8C14 7.65397 13.9694 7.29662 13.9129 6.96156Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleAlt);
export default __webpack_public_path__ + "static/media/google-alt.ea3163b79c97ca0dd6fa6e5c134d6ee5.svg";
export { ForwardRef as ReactComponent };